"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTouchDevice = void 0;
const isTouchDevice = () => {
    // If Modernizr set feature-detection class
    if (document.documentElement.classList.contains('touchevents')) {
        return true;
    }
    // Taken from Modernizr source before deprecation.
    const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
    const mq = function (query) {
        return window.matchMedia(query).matches;
    };
    if ('ontouchstart' in window ||
        (window['DocumentTouch'] && document instanceof window['DocumentTouch'])) {
        return true;
    }
    // include the 'heartz' as a way to have a non matching MQ to help terminate the join
    // https://git.io/vznFH
    const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
    return mq(query);
};
exports.isTouchDevice = isTouchDevice;
